import React, { useMemo } from 'react'

interface EmberFieldProps {
  count?: number
  style?: React.CSSProperties
}

// Slow-rising ember / candle motes — Sanctum's atmospheric texture layer.
// Pure CSS animation (transform/opacity only), capped at a cheap element
// count, and disabled entirely under prefers-reduced-motion via global.css.
export function EmberField({ count = 22, style }: EmberFieldProps) {
  const embers = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      left: `${(i * 97) % 100}%`,
      size: 2 + ((i * 7) % 5),
      duration: 9 + ((i * 3) % 10),
      delay: -((i * 1.7) % 14),
      driftX: ((i % 2 === 0 ? 1 : -1) * (8 + (i % 5) * 4)),
      opacity: 0.35 + ((i % 4) * 0.12),
    }))
  }, [count])

  return (
    <div aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', ...style }}>
      {embers.map((e) => (
        <span
          key={e.id}
          className="s-ember"
          style={{
            left: e.left,
            width: e.size,
            height: e.size,
            animationDuration: `${e.duration}s`,
            animationDelay: `${e.delay}s`,
            ['--ember-x' as any]: `${e.driftX}px`,
            ['--ember-o' as any]: e.opacity,
          }}
        />
      ))}
    </div>
  )
}
